export interface FeatureCardData {
  id: string
  videoFileName: string
  posterFileName: string
}

export const FEATURE_CARDS: FeatureCardData[] = [
  {
    id: 'image_editor',
    videoFileName: '01-image-editor.webm',
    posterFileName: '01-image-editor.webp',
  },
  {
    id: 'video_generator',
    videoFileName: '02-video-generator.webm',
    posterFileName: '02-video-generator.webp',
  },
  {
    id: 'nanobanana_2',
    videoFileName: '03-nano-banana.webm',
    posterFileName: '03-nano-banana.webp',
  },
  {
    id: 'music_generator',
    videoFileName: '04-music-generator.webm',
    posterFileName: '04-music-generator.webp',
  },
  {
    id: 'logo_generator',
    videoFileName: '05-logo-generator.webm',
    posterFileName: '05-logo-generator.webp',
  },
  {
    id: 'seedream_2',
    videoFileName: '06-seedream.webm',
    posterFileName: '06-seedream.webp',
  },
  {
    id: 'lyria_3',
    videoFileName: '07-lyria3.webm',
    posterFileName: '07-lyria3.webp',
  },
]
